import { render, staticRenderFns } from "./customersLog.vue?vue&type=template&id=1cef7ade&scoped=true&"
import script from "./customersLog.vue?vue&type=script&lang=js&"
export * from "./customersLog.vue?vue&type=script&lang=js&"
import style0 from "./customersLog.vue?vue&type=style&index=0&id=1cef7ade&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cef7ade",
  null
  
)

export default component.exports